import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Utils/Breadcrumb";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { GetDashboardRole } from "../../Components/Utils/roles";
import { useNumber } from "../../Context/ProjectIdContext";
import axiosInstance from "../../Services/axiosCommon";
import { Select } from "antd";

const DashboardLayout = (
    {
        getData=() => {},
    }
) =>{
    const location = useLocation();
    let pathFile = location.pathname;
    const {officeId} = useParams();
        const [projectList,setProjectList]= useState([])
    
    let LinkItem = [
        {
            label:"Overall",
            link:`/main/${officeId}/dashboard`,
            access:GetDashboardRole(""),
        },
        {
            label:"Project",
            link:`/main/${officeId}/dashboard/project`,
            access:GetDashboardRole(""),
        },
        
    ]

    const {number, updateNumber} = useNumber()

    function getProjectByOffice(id){
        axiosInstance.get(`/DropDown/${id}/getAllProjects`).then(res=>{
            let tempValue = res?.data?.data||[];
            let arr = []
            tempValue.map(i=>{
                let val = {
                    value:i?.projId||"",
                    label:i?.projName||""
                }
                arr.push(val)
            })
            if(number ==0){
                updateNumber(arr[0]?.value)
            }
            setProjectList(arr)
        }).catch((error) => {
            console.error("Error:", error);
              
          });
    }

    useEffect(()=>{
        if(number==0||pathFile !="") getProjectByOffice(officeId)
    },[pathFile])

    function handleProjectChange(e){
        console.log(e);
        updateNumber(e)
    }

  return (
    <div className=" w-full h-full  px-4 py-2 overflow-hidden">
      {/* <Breadcrumb items={[]} /> */}

      <div className="w-[100%] h-[calc(100vh-90px)] mt-2">
        <div className="flex w-full gap-4 lg:mr-3">
        <div className=" h-8 flex items-center gap-x-1 ">
  {LinkItem &&
    LinkItem.map((item, i) => {
      const isActive = item.link === pathFile;
      return (
        <Link
          key={item.link}
          to={item.link}
          className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${
            isActive
              ? "border-b-2 border-baseColor-primary"
              : "border-b-2 border-transparent"
          }`}
        >
          {item.label}
        </Link>
      );
    })}
</div>

        {
  pathFile === `/main/${officeId}/dashboard/project` && (

        <form className=" w-full flex" onSubmit={getData}>
        <div className="text-baseColor-primary  text-xs 2xl:text-sm font-medium lg:flex mt-1 hidden ">
           {/*  <p>Project</p> */}
            {/* <p className="pr-2">:</p>  */}
            </div>
          <Select
          style={{
            width: '35%',
              }}
            options={projectList}
            value={number}
            disabled={projectList.length >= 2 ? false : true}
            onChange={handleProjectChange}
          />
            </form>)}
            </div>
        <div className="w-[100%] h-[calc(100vh-141px)] overflow-y-auto">
            <Outlet/>

        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;


